<template>
  <v-flex>
    <div v-if="jwt.role_id === 100 || jwt.role_id === 200" class="mb-6">
      <v-btn to="/machine/create" color="orange">新增</v-btn>
    </div>

    <div class="row">
        <div class="col-4 col-md-3 py-0">
            <v-select
                v-model="filterSerialNumber"
                :items="itemsSerialNumber"
                placeholder="過濾機器序號"
                outlined
                @change="getResult()">
            </v-select>
        </div>
    </div>

    <v-data-table :headers="thead" :items="machines" disable-pagination hide-default-footer>
      <template v-slot:item.no="{ item }">
        <span class="blue--text">{{ item.no }}</span>
      </template>

      <template v-slot:item.online="{ item }">
        <template v-if="item.online">
          <v-icon color="green" class="mr-3">mdi-checkbox-blank-circle</v-icon>連線
        </template>
        <template v-else>
          <v-icon color="red" class="mr-3">mdi-checkbox-blank-circle</v-icon>離線
        </template>
      </template>

      <template v-slot:item.malfunction="{ item }">
        <template v-if="item.malfunction">
          <v-icon color="red" class="mr-3">mdi-checkbox-blank-circle</v-icon>異常
        </template>
        <template v-else>
          <v-icon color="green" class="mr-3">mdi-checkbox-blank-circle</v-icon>正常
        </template>
      </template>

      <template v-slot:item.serial_number="{ item }">
        <v-btn :to="`/machine/${item.machine_id}`" outlined color="blue">{{ item.serial_number }}</v-btn>
      </template>
    </v-data-table>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import machineApi from "@/api/machine";

export default {
  components: {},

  mixins: [],

  props: [],
  data() {
    return {
      machines: [],

      filterSerialNumber: '',

      itemsSerialNumber:[
        'CCB',
        'CCA',
        'MU'
      ],

      thead: [
        {
          text: "",
          value: "no",
          align: "center"
        },
        {
          text: "連線狀態",
          value: "online",
          align: "center"
        },
        {
          text: "機器序號",
          value: "serial_number",
          align: "center"
        },
        {
          text: "機器名稱",
          value: "name"
        },
        {
          text: "地址",
          value: "address"
        },
        {
          text: "設備狀態",
          value: "malfunction",
          align: "center"
        },
        {
          text: "版本",
          value: "version",
          align: "center"
        }
      ]
    };
  },

  computed: {
    ...mapState("admin", ["jwt"])
  },
  watch: {},
  methods: {
    getResult(){
        machineApi
          .getAll(this.filterSerialNumber)
          .then(res => {
            this.machines = res.machines;

            this.machines.forEach((item, idx) => {
              item.no = idx + 1;
            });
          })
          .catch(err => {});
    }
  },

  mounted() {
    machineApi
      .getAll(this.filterSerialNumber)
      .then(res => {
        this.machines = res.machines;

        this.machines.forEach((item, idx) => {
          item.no = idx + 1;
        });
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
